var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSizeDefaultSelected = function SvgSizeDefaultSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0E6",
    fillOpacity: 0.5,
    d: "M.5.5h99v99H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 65h78v19H11zM11 40h78v19H11zM11 15h78v19H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DACFF",
    d: "M16 20h68v9H16zM16 45h68v9H16zM16 70h68v9H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4DACFF",
    d: "M.5.5h99v99H.5z"
  })));
};
export { SvgSizeDefaultSelected as ReactComponent };
export default __webpack_public_path__ + "img/size-default-selected.6f135ae53e561cd86ac97244afe8d502.svg";